<svg width="534" height="823" viewBox="0 0 534 823" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="176.817" cy="219.295" r="65" transform="rotate(169.703 176.817 219.295)" fill="url(#paint0_linear_42_189)"/>
    <circle cx="48.4784" cy="248.101" r="29" transform="rotate(169.703 48.4784 248.101)" fill="url(#paint1_linear_42_189)"/>
    <circle cx="189.479" cy="639.604" r="20.5818" transform="rotate(169.703 189.479 639.604)" fill="url(#paint2_linear_42_189)"/>
    <circle cx="179.453" cy="343.615" r="20.5818" transform="rotate(169.703 179.453 343.615)" fill="url(#paint3_linear_42_189)"/>
    <circle cx="502.156" cy="428.693" r="289.5" transform="rotate(-16.0404 502.156 428.693)" fill="url(#paint4_linear_42_189)"/>
    <defs>
    <linearGradient id="paint0_linear_42_189" x1="176.817" y1="284.295" x2="450.326" y2="-69.997" gradientUnits="userSpaceOnUse">
    <stop stop-color="#FDC029"/>
    <stop offset="1" stop-color="#F55200"/>
    </linearGradient>
    <linearGradient id="paint1_linear_42_189" x1="48.4784" y1="277.101" x2="-26.7233" y2="166.199" gradientUnits="userSpaceOnUse">
    <stop stop-color="#FDC029"/>
    <stop offset="1" stop-color="#F55200"/>
    </linearGradient>
    <linearGradient id="paint2_linear_42_189" x1="189.479" y1="660.186" x2="136.107" y2="581.477" gradientUnits="userSpaceOnUse">
    <stop stop-color="#FDC029"/>
    <stop offset="1" stop-color="#F55200"/>
    </linearGradient>
    <linearGradient id="paint3_linear_42_189" x1="179.453" y1="364.197" x2="126.081" y2="285.489" gradientUnits="userSpaceOnUse">
    <stop stop-color="#FDC029"/>
    <stop offset="1" stop-color="#F55200"/>
    </linearGradient>
    <linearGradient id="paint4_linear_42_189" x1="317.656" y1="229.193" x2="895.656" y2="846.193" gradientUnits="userSpaceOnUse">
    <stop stop-color="#FDC029"/>
    <stop offset="1" stop-color="#F55200"/>
    </linearGradient>
    </defs>
</svg>
    